import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlmacenMenajeriaRoutingModule } from './almacen-menajeria-routing.module';
import { AlmacenMenajeriaComponent } from './almacen-menajeria.component';
import { InventarioComponent } from './inventario/inventario.component';
import { StockComponent } from './stock/stock.component';
import { IngresoComponent } from './ingreso/ingreso.component';
import {RouterModule} from "@angular/router";
import {MaterialModule} from "../material/material.module";
import {ReactiveFormsModule} from "@angular/forms";
import { DialogInventarioMenajeriaComponent } from './inventario/dialog-inventario-menajeria/dialog-inventario-menajeria.component';


@NgModule({
  declarations: [
    AlmacenMenajeriaComponent,
    InventarioComponent,
    StockComponent,
    IngresoComponent,
    DialogInventarioMenajeriaComponent
  ],
  imports: [
    CommonModule,
    AlmacenMenajeriaRoutingModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule
  ]
})
export class AlmacenMenajeriaModule { }
